import React, { useContext, useEffect } from "react";
import { FaceGallery, FaceScan, Home, Logout, NotFound } from "../pages"
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import AuthRoute from "./AuthRoute";
import { history } from "../helpers";
import { AuthContext } from "../context";
import FaceScanRoute from "./FaceScanRoute";

const routes = [
  { path: "/home", component: Home },
  { path: "/face-gallery", component: FaceGallery, guard: 'private' },
  { path: "/face-scan", component: FaceScan, guard: 'private' },
  { path: "/", component: Home },
  { path: "/*", component: NotFound },

];

function AppRouter({ }) {
  const { user } = useContext(AuthContext);
  

  return (
    <Router history={history}>
      <Switch>
        <Route exact path="/" component={Home} />
        <AuthRoute exact path="/face-gallery" user={user} component={FaceGallery} />
        <FaceScanRoute exact path="/face-scan" user={user} component={FaceScan} />
        <AuthRoute exact user={user} path="/logout" component={Logout} />
        <AuthRoute user={user} component={NotFound} />
      </Switch>
    </Router>
  )
}

export default AppRouter;









